<div class="proto">
	<h2>Crop type match prototype</h2>

	<label class="typeahead">
		Crop
		<input
			type="text"
			[(ngModel)]="typeaheadQuery"
			(ngModelChange)="onTypeaheadChange()"
			(focus)="typeaheadOpen = true"
			(blur)="onTypeaheadBlur()"
			placeholder="Start typing a crop name…"
			autocomplete="off"
		/>
		<ul *ngIf="typeaheadOpen && filteredGenericNames.length">
			<li
				*ngFor="let g of filteredGenericNames"
				(mousedown)="selectGenericName(g)"
			>{{ g }}</li>
		</ul>
	</label>
	<p class="selected" *ngIf="genericName">Selected: <strong>{{ genericName }}</strong></p>

	<label *ngIf="showPlantingSystem()">
		Planting system
		<select [(ngModel)]="plantingSystem" (ngModelChange)="resetAnswers(); resolve()">
			<option [ngValue]="null">—</option>
			<option [ngValue]="NURSERY">Nursery (Mother and Daughter)</option>
			<option [ngValue]="FIELD">{{ FIELD }}</option>
		</select>
	</label>

	<label *ngIf="showRegion()">
		Region
		<select [(ngModel)]="region" (ngModelChange)="resolve()">
			<option [ngValue]="null">—</option>
			<option *ngFor="let r of regionOptions()" [ngValue]="r">{{ r }}</option>
			<option [ngValue]="OTHER">{{ OTHER }}</option>
		</select>
	</label>

	<label *ngIf="showSeason()">
		Season
		<select [(ngModel)]="season" (ngModelChange)="resolve()">
			<option [ngValue]="null">—</option>
			<option *ngFor="let s of seasonOptions()" [ngValue]="s">{{ s }}</option>
			<option [ngValue]="OTHER">{{ OTHER }}</option>
		</select>
	</label>

	<label *ngIf="showProductClass()">
		Product class
		<select [(ngModel)]="productClass" (ngModelChange)="resolve()">
			<option [ngValue]="null">—</option>
			<option *ngFor="let p of productClassOptions()" [ngValue]="p">{{ p }}</option>
			<option [ngValue]="OTHER">{{ OTHER }}</option>
		</select>
	</label>

	<label *ngIf="showAge()">
		Age
		<select [(ngModel)]="age" (ngModelChange)="resolve()">
			<option [ngValue]="null">—</option>
			<option *ngFor="let a of ageOptions()" [ngValue]="a">{{ a }}</option>
			<option [ngValue]="OTHER">{{ OTHER }}</option>
		</select>
	</label>

	<label *ngIf="showBrand()">
		Brand
		<select [(ngModel)]="brand" (ngModelChange)="resolve()">
			<option [ngValue]="null">—</option>
			<option [ngValue]="BRAND_ALBION">{{ BRAND_ALBION }}</option>
			<option [ngValue]="OTHER">{{ OTHER }}</option>
		</select>
	</label>

	<div *ngIf="showBedRows()" class="row">
		<label>
			Bed width (in)
			<input type="number" [(ngModel)]="bedWidth" (ngModelChange)="resolve()" />
		</label>
		<label>
			Rows
			<input type="number" [(ngModel)]="rows" (ngModelChange)="resolve()" />
		</label>
	</div>

	<p class="match" *ngIf="matchedName">
		Matched default: <strong>{{ matchedName }}</strong>
	</p>
	<p class="match muted" *ngIf="genericName && !matchedName">
		Fill remaining fields to match…
	</p>
</div>
